export default __webpack_public_path__ + "static/media/character_03.f12544c2.png";